'use client';

import { StyledArrowButton } from './style';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { ButtonProps } from '@mui/material';

export enum ArrowDirection {
    left,
    right
}

interface Props extends ButtonProps {
    direction: ArrowDirection;
}

export const ArrowButton = ({ direction, ...buttonProps }: Props) => {
    const icon = direction === ArrowDirection.left ? <KeyboardArrowLeft /> : <KeyboardArrowRight />;
    return <StyledArrowButton icon={icon} {...buttonProps} />;
};
